var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.9496 17.7002c-.19 0-.38-.07-.53-.22-.29-.29-.29-.77 0-1.06 1.18-1.18 1.83-2.75 1.83-4.42s-.65-3.23996-1.83-4.41996c-.29-.29-.29-.77001 0-1.06001s.77-.29 1.06 0c1.46 1.46 2.27 3.41001 2.27 5.47997 0 2.07-.81 4.02-2.27 5.48-.15.15-.34.22-.53.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.04999 17.7002c-.19 0-.38-.07-.53-.22-1.46-1.46-2.26999-3.41-2.26999-5.48 0-2.06996.80999-4.01997 2.26999-5.47997.29-.29.77-.29 1.06 0s.29.77001 0 1.06001c-1.18 1.18-1.82999 2.74996-1.82999 4.41996s.64999 3.24 1.82999 4.42c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 22.75c-5.93 0-10.75-4.82-10.75-10.75s4.82-10.75 10.75-10.75 10.75 4.82 10.75 10.75-4.82 10.75-10.75 10.75zm0-20c-5.1 0-9.25 4.15-9.25 9.25s4.15 9.25 9.25 9.25 9.25-4.15 9.25-9.25-4.15-9.25-9.25-9.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenCoin);
export default __webpack_public_path__ + "static/media/token-coin.6529f3840e4171dd68591a9857b8cc00.svg";
export { ForwardRef as ReactComponent };